import { createSlice } from "@reduxjs/toolkit";
import {
  AllBlogsThunk,
  GetSingleBlogsThunk,
  AddBlogsThunk,
  UpdateBlogsThunk,
  DeleteBlogsThunk,
  AllBlogsCategoryThunk,
} from "./thunk";

const initialState = {
  blogs: [],
  category: [],
  singleBlog: null,
  loading: false,
  error: null,
  successMessage: null,
};

const blogsSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    clearBlogState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // -------------------- ALL BLOGS --------------------
      .addCase(AllBlogsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllBlogsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = action.payload?.data || [];
      })
      .addCase(AllBlogsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- SINGLE BLOG --------------------
      .addCase(GetSingleBlogsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleBlogsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleBlog = action.payload?.data || null;
      })
      .addCase(GetSingleBlogsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- ADD BLOG --------------------
      .addCase(AddBlogsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(AddBlogsThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Blog added successfully!";
      })
      .addCase(AddBlogsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- UPDATE BLOG --------------------
      .addCase(UpdateBlogsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(UpdateBlogsThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Blog updated successfully!";
      })
      .addCase(UpdateBlogsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- DELETE BLOG --------------------
      .addCase(DeleteBlogsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(DeleteBlogsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = state.blogs.filter((b) => b.uuid !== action.payload.uuid);
        state.successMessage = "Blog deleted successfully!";
      })
      .addCase(DeleteBlogsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- ALL CATEGORY --------------------
      .addCase(AllBlogsCategoryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllBlogsCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.category = action.payload?.data || [];
      })
      .addCase(AllBlogsCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBlogState } = blogsSlice.actions;
export default blogsSlice.reducer;
